//
//
//
//
//
//
//
//
//
//

import * as api from '~/api/index';
import articleList from '~/components/index/article-list.vue';
import LogoBtn from '~/components/public/logo-btn.vue';
import { throttle } from '~/utils';
export default {
  name: 'Home1',
  components: {
    ArticleList: articleList,
    LogoBtn,
  },
  async asyncData({ $http, $axios, error, route }) {
    const type = route.params.type ? route.params.type : 'web_home_page';
    let articleResult = null;
    let timestamp = null;
    let loaded = 0;
    const [err, getChannelArticleData] = await $http(
      api.getChannelArticle({ type })
    );
    if (err) {
      error({
        statusCode: 404,
        message: {
          title: '很抱歉您访问的页面出错了！',
          desc:
            '可能原因：1、系统繁忙；2、网络链接失败；3、找不到请求页面；' +
            `4: api.getChannelArticle({${type}}) failed`,
        },
      });
    }
    articleResult = getChannelArticleData?.result ?? null;
    if (articleResult) {
      loaded += articleResult.length;
      articleResult = articleResult.filter(item => item.data);
      timestamp = articleResult
        ? articleResult[articleResult.length - 1].data.timestamp - 1
        : null;
    }
    const [err1, getHomeArticleData] = await $http(api.getHomeArticle());
    if (err1) {
      error({
        statusCode: 404,
        message: {
          title: '很抱歉您访问的页面出错了！',
          desc:
            '可能原因：1、系统繁忙；2、网络链接失败；3、找不到请求页面；' +
            `4: api.getHomeArticle() failed`,
        },
      });
    }
    const homeArticles = getHomeArticleData?.result ?? [];
    let hotspots = homeArticles.filter(item => item.type === 'popularHotspots');
    hotspots = (hotspots.length > 0 && hotspots[0]) || null;
    hotspots = hotspots?.data?.subjects ?? null;
    if (
      hotspots &&
      hotspots.length > 0 &&
      articleResult &&
      articleResult.length > 0
    ) {
      const obj = {
        type: 'hotspots',
        list: hotspots,
      };
      if (articleResult.length < 4) {
        articleResult.push(obj);
      } else {
        articleResult.splice(4, 0, obj);
      }
    }

    return {
      type,
      articleList: articleResult || [],
      timestamp,
      loaded,
    };
  },
  data() {
    return {
      routerTag: '',
      pageTag: '',
      more: true,
      loadTime: 1,
      loading: false,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.hanlder);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.hanlder);
  },
  methods: {
    async getMore() {
      this.loadTime++;
      this.loading = true;
      if (this.loadTime >= 4) {
        window.removeEventListener('scroll', this.hanlder);
      }
      let articleResult = null;
      articleResult = await this.$axios(
        api.getChannelArticle({
          type: this.type,
          timestamp: this.timestamp,
          loaded: this.loaded,
        })
      );
      articleResult = articleResult?.result ?? null;

      this.timestamp = articleResult
        ? articleResult[articleResult.length - 1].data.timestamp - 1
        : null;
      if (articleResult) {
        this.loaded += articleResult.length;
        articleResult = articleResult.filter(item => item.data);
        this.articleList = [...this.articleList, ...articleResult];
        this.more = articleResult.length === 0 ? false : true;
        this.loading = false;
      } else {
        this.more = false;
        this.loading = false;
      }
    },
    hanlder() {
      const self = this;
      const articleDom = self.$refs.articleList;
      const scrollLen =
        document.documentElement.scrollTop || document.body.scrollTop;
      const [articleOffsetTop, articleOffsetHeight] = [
        articleDom.offsetTop,
        articleDom.offsetHeight,
      ];
      const isGetMore =
        scrollLen - articleOffsetTop >= articleOffsetHeight - 600;
      if (isGetMore && !self.loading) {
        throttle(self.getMore(), 2000);
      }
    },
  },
};
